<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header-out">
        <v-card class="ma-3">
          <v-card-title>
            <h2>Solicitudes</h2>
          </v-card-title>
          <v-card-text>
            <v-layout v-if="newLaboralDocuments > 0">
              <v-flex xs12>
                <v-alert :value="'true'" color="warning" icon="new_releases" outline>
                  {{ $t('Tiene un total de') }} {{ newLaboralDocuments }}
                  {{ $t(' nueva/s documentación añadida a solicitudes ') }}
                </v-alert>
              </v-flex>
            </v-layout>

            <laboral-requests
              :key="`laboral-requests-${laboralRequestsKey}`"
              v-if="codempre"
              :codempre="codempre"
              @entity-saved="refreshWorkers()"
              @refresh-laboral-request-documents="getNewLaboralRequestDocuments()"
            ></laboral-requests>
          </v-card-text>
        </v-card>
        <v-card class="ma-3">
          <v-card-title>
            <h2>Contratos de Trabajadores</h2>
          </v-card-title>
          <v-card-text>
            <workers
              :key="`workers-${workersKey}`"
              v-if="codempre"
              :codempre="codempre"
              @entity-saved="refreshLaboralRequests()"
            ></workers>
          </v-card-text>
        </v-card>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import Workers from '../components/Workers.vue';
import LaboralRequests from '../components/LaboralRequests.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  components: {
    DashboardLayout,
    MyConsultantConversation,
    CalendarEvents,
    AppLayout,
    LaboralRequests,
    Workers,
  },
  data() {
    return {
      workersKey: 1,
      laboralRequestsKey: 1,
      newLaboralDocuments: 0,
    };
  },
  mounted() {
    this.getNewLaboralRequestDocuments();
  },
  methods: {
    refreshWorkers() {
      this.workersKey++;
    },
    refreshLaboralRequests() {
      this.laboralRequestsKey++;
    },
    getNewLaboralRequestDocuments() {
      if (this.$store.state.user) {
        apiCtrl
          .get('/laboral-requests/new-documents', {
            params: {
              codempre: this.codempre,
            },
          })
          .then(res => {
            this.newLaboralDocuments =
              (res.hasOwnProperty('data') &&
                res.data &&
                res.data.hasOwnProperty('documents') &&
                res.data.documents) ||
              0;
          });
      }
    },
  },
  computed: {
    currentCompany() {
      return this.$store.getters['currentCompany'];
    },
    codempre() {
      return this.currentCompany ? this.currentCompany.CLAVEDAT : null;
    },
  },
};
</script>
